// @flow

import React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';

type Props = {
  classes: Object,
  sheet: Object,
  children: Object | Array<Object>,
  className?: string,
  disabled?: boolean,
};

const defaultProps = {
  disabled: false,
  className: '',
};

function FriendGroupActionPanel({
  classes,
  sheet,
  children,
  className,
  disabled,
  ...otherProps
}: Props) {
  return (
    <div {...otherProps} className={classNames(classes.actionPanel, className, { disabled })}>
      {children}
    </div>
  );
}

FriendGroupActionPanel.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    actionPanel: {
      position: 'relative',
      height: 45,
      flexShrink: 0,
      backgroundColor: theme.color.basis4,
      transition: 'background-color 0.2s',
      color: theme.color.basis3,
      display: 'flex',
      alignItems: 'center',
      padding: '0 10px',
      fontSize: theme.fontSize.medium,
      [theme.mediaQuery.desktopAndUp]: {
        // height: 30,
      },
      '&.disabled': {
        backgroundColor: theme.color.basis6,
        color: theme.color.basis4,
        cursor: 'not-allowed !important',
      },
    },
  };
}

export default useSheet(applyStyles)(FriendGroupActionPanel);
